import { LANGUAGE_CODES, LANGUAGE_EXCEPTIONS } from './languageCodes';

const getFlagIcon = code => {
    return require(`../../assets/flags/flag-${code || 'en'}.svg`);
};

export const languages = Object.fromEntries(
    Object.entries(LANGUAGE_CODES).map(([key, code]) => [
        key,
        {
            value: code,
            label: LANGUAGE_EXCEPTIONS[code]?.label || code.toUpperCase(),
            icon: getFlagIcon(code),
        },
    ])
);
